import { createMerchV2Thunks, createMerchV2Slice } from '@amzn/d2c-application-website-common';
import { RoadieService } from 'src/services/roadie';
import { awsRum } from 'src/rum';

const thunks = createMerchV2Thunks(
  (_stage: string, csrfToken?: string) => new RoadieService(csrfToken),
  {
    error: (message, context) => { awsRum?.recordEvent('MerchV2Error', { message, ...context }); },
    recordAPIError: (site, api, status) => { awsRum?.recordEvent('APIError', { site, api, status }); },
    recordAPIRequest: (site, api) => { awsRum?.recordEvent('APIRequest', { site, api }); },
  },
);

export const { fetchCollectionV2 } = thunks;
const merchV2Slice = createMerchV2Slice(thunks);
export const { replaceMerchV2State } = merchV2Slice.actions;
export default merchV2Slice.reducer;

export {
  selectGetCollectionV2InProgress,
  selectCollectionsV2,
  selectMerchV2Error,
} from '@amzn/d2c-application-website-common';
